import { render } from "./identify.vue?vue&type=template&id=c6c911de&scoped=true&ts=true"
import script from "./identify.vue?vue&type=script&lang=ts"
export * from "./identify.vue?vue&type=script&lang=ts"

import "./identify.vue?vue&type=style&index=0&id=c6c911de&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6c911de"]])

export default __exports__